<template>
    <MarketingModal v-if="!settings.is_sourcing_mode" :title="`${$t('Cut Sheet')} – ${data.sku}`">
        <template #subheader>
            <div class="text-center mt-8">
                <span class="font-medium">{{ $t("Please note") }}:</span>
                {{ $t("this is a SECLOCK.com branded email") }}.
            </div>
        </template>
        <div>
            <div class="w-full h-12 overflow-hidden border-gray-350 duration-150 flex items-center border rounded-sm focus-within:border-royal ring-1 ring-transparent focus-within:ring-royal mb-0">
                <input
                    v-model="form.email"
                    type="email"
                    class="grow text-lg outline-none border-none focus:outline-none focus:ring-0 font-medium"
                />
                <button
                    @click.stop.prevent="emailCutSheet(data.slug)"
                    :disabled="form.processing"
                    class="uppercase font-medium text-sm type-secondary whitespace-nowrap hover:type-primary h-full w-fit px-5 bg-gray-125 at480:tracking-widest hover:bg-gray-150 active:bg-gray-225"
                >
                    {{ buttonText }}
                </button>
            </div>
            <div
                v-if="form.errors?.email"
                class="text-red mb-8"
                v-html="form.errors?.email"
            ></div>
            <Divider class="my-8" />
            <div
                class="w-full flex font-medium mb-4 items-center justify-center"
            >
                {{ $t("Download") }}
            </div>
            <button
                @click="downloadCutSheet(data.slug)"
                :disabled="isDownloading"
                class="w-full flex items-center justify-center gap-2 btn-white-on-black"
            >
                <LoadingCircle v-if="isDownloading" />
                <BaseSvg v-else name="icon-export-file" />
                {{ $t("Download PDF") }}
            </button>
        </div>
    </MarketingModal>
    <AppModal
        v-else
        :title="$t('Cut Sheet') + ' – ' + data.sku"
        :read-only="true"
        :close-on-success="true"
        :scroll="false"
    >
        <template #content>
            <div class="px-6 py-4">
                <div class="font-medium text-base">{{ $t("Send Email") }}</div>
                <div class="type-secondary mb-4">
                    <span class="font-medium">{{ $t("Please note") }}:</span>
                    {{ $t("this is a SECLOCK.com branded email") }}.
                </div>
                <div class="w-full items-center flex gap-3 mb-4">
                    <AppInput
                        v-model="form.email"
                        :error="form.errors?.email"
                        type="email"
                        class="grow"
                    />
                    <AppButton
                        @click.stop.prevent="emailCutSheet(data.slug)"
                        :text="buttonText"
                        :disabled="form.processing"
                        size="large"
                    />
                </div>
                <Divider class="mb-4" />
                <div class="font-medium mb-4">{{ $t("Download") }}</div>
                <AppButton
                    :loading="isDownloading"
                    @click="downloadCutSheet(data.slug)"
                    icon="export-file"
                    text="Download PDF"
                />
            </div>
        </template>
    </AppModal>
</template>
<script setup>
import {
    Divider,
    BaseSvg,
    AppInput,
    AppButton,
    AppModal,
    MarketingModal, LoadingCircle,
} from "@/Components";
import { eventBus, useUser } from "@/Composables";
import { computed, onMounted } from "vue";
import useCutSheet from "@/Composables/Modules/useCutSheet";

const props = defineProps(["data"]);
const { settings } = useUser();

onMounted(() => {
    eventBus.on("form:reset", () => form.reset());
});

const { emailCutSheet, downloadCutSheet, form, isDownloading } = useCutSheet();

const buttonText = computed(() => {
    return form.processing ? "Sending" : "Send Email";
});
</script>
